<app-navbar style="z-index: 5;" class="light"></app-navbar>
<app-management-table class="light"></app-management-table>
<app-footer class="light"></app-footer>